import { render, staticRenderFns } from "./growing.vue?vue&type=template&id=04738aa6&scoped=true&"
import script from "./growing.vue?vue&type=script&lang=js&"
export * from "./growing.vue?vue&type=script&lang=js&"
import style0 from "./growing.vue?vue&type=style&index=0&id=04738aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04738aa6",
  null
  
)

export default component.exports